const handleApiResponse = (
  enqueueSnackbar,
  response,
  successSnackbar,
  variant = null,
  action = null,
  autoHideDuration = 3000,
) => {
  if (successSnackbar) {
    enqueueSnackbar(response.message, {
      variant: variant || 'success',
      action,
      autoHideDuration,
    });
  } else {
    const errorMessage = response.response && response.response.data ? response.response.data.errorMessage || 'Ha ocurrido un error inesperado' : 'Ha ocurrido un error inesperado';
    enqueueSnackbar(errorMessage, {
      variant: variant || 'error',
      action,
      autoHideDuration,
    });
  }
};

export default handleApiResponse;
